import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import App from '@/app';
import '@/styles/index.css';

// Extend window type
declare global {
  interface Window {
    __APP_PROPS__?: any;
    optiSSRHydrated?: boolean;
  }
}

async function hydrateApp() {
  if (window.optiSSRHydrated) {
    return;
  }

  const root = document.getElementById('root');
  
  if (!root) {
    return;
  }

  // Get props from window
  const props = window.__APP_PROPS__ || {};

  try {
    const hasServerRendering =
      root.innerHTML.trim().length > 0 && !root.innerHTML.includes('SSR failed');

    const element = React.createElement(App, props);

    if (hasServerRendering) {
      try {
        // Use hydrateRoot with onRecoverableError to handle hydration mismatches gracefully
        hydrateRoot(root, element, {
          onRecoverableError: (error) => {
            // Log hydration errors
            console.warn('Hydration mismatch recovered');
          }
        });
      } catch (hydrationError) {
        console.warn('Hydration failed, falling back to client render:', hydrationError);
        root.innerHTML = '';
        const clientRoot = createRoot(root);
        clientRoot.render(element);
      }
    } else {
      const clientRoot = createRoot(root);
      clientRoot.render(element);
    }
  } catch (error) {
    console.error('Failed to render app:', error);
    try {
      root.innerHTML = '';
      const fallbackRoot = createRoot(root);
      fallbackRoot.render(React.createElement(App, props));
    } catch (fallbackError) {
      console.error('Fallback render also failed:', fallbackError);
    }
  }

  window.optiSSRHydrated = true;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', hydrateApp);
} else {
  setTimeout(hydrateApp, 0);
}
